import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import { goToPractice } from '../../../common/navigation/navigationActions';
import MultiChoiceQuestionView from '../../../common/questions/multiChoiceQuestionView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import { WR, ACCURACY } from '../../../constants/measure';
import { MODEL, MODELING } from '../../../constants/assessmentItemType';
import { narrateScreen, modelScreenResponseClick } from './WRModelActions';
import { fetchWRContent } from '../../wrActions';
import WR_AUDIO_INSTRUCTIONS from '../../wrConstants';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const mapStateToProps = state => ({
    ...multiChoiceUtils.mapStateToProps(state),
    // TODO: so far let it be RCT layout
    pageLayout: `${'rct'}-${ACCURACY} ${MODELING}`,
    isDataFetched: selectors.getIsWRDataFetched(state),
    possibleResponses: selectors.getWRPossibleResponses(state, MODEL),
    stimulusAudio: selectors.getWRStimulusAudio(state, MODEL),
});

const mapDispatchToProps = dispatch => ({
    ...multiChoiceUtils.mapDispatchToProps(dispatch),
    selectResponse: index => {
        dispatch(modelScreenResponseClick(index));
    },
    fetchContent: () => {
        dispatch(fetchWRContent());
    },
    narrateScreen: stimulusAudio => {
        dispatch(narrateScreen(stimulusAudio));
    },
    onNext: () => {
        dispatch(goToPractice(WR.KEY));
    },
});

const avatarMapStateToProps = () => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        animateAlex: true,
        position,
        instructions: WR_AUDIO_INSTRUCTIONS.avatarInstructionModel,
    };
};

const WRModelContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MultiChoiceQuestionView);

export default WRModelContainer;
